var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "removePage"
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": _vm.homeLogo
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$cm.title))])]), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm.isNeedPassCode ? _c('div', [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('addWords.enterPassWord')
    },
    model: {
      value: _vm.passWord,
      callback: function ($$v) {
        _vm.passWord = $$v;
      },
      expression: "passWord"
    }
  })], 1) : _vm._e(), _c('p', [_vm._v(_vm._s(_vm.text))]), _c('el-button', {
    staticClass: "right",
    on: {
      "click": _vm.jump
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };